import clsx from "clsx";
import * as React from "react";
import { DividerV2 } from "../DividerV2";

interface InfoListLinkProps {
  children: React.ReactNode;
  action: () => void;
  title?: string;
}

export const InfoList = ({ children, ...rest }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div className="rounded-sm" {...rest}>
      {children}
    </div>
  );
};

export const InfoListTitle = ({ children, ...rest }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div>
      <div
        {...rest}
        className="items-center px-3 py-3 text-sm font-semibold leading-none text-text-base-primary md:text-base"
      >
        {children}
      </div>
      <DividerV2 orientation={"horizontal"} />
    </div>
  );
};
InfoList.Title = InfoListTitle;

const InfoListItem = ({ children, ...rest }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div {...rest} className={clsx("px-3 py-2 text-xs md:text-sm gap-5 bg-white", rest && rest.className)}>
      {children}
    </div>
  );
};

InfoList.Item = InfoListItem;

const InfoListItemTitle = ({ children, ...rest }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div className="font-semibold text-text-base-primary" {...rest}>
      {children}
    </div>
  );
};

InfoList.ItemTitle = InfoListItemTitle;

const InfoListItemValue = ({ children, ...rest }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div className="text-neutral-800 py-0.5" {...rest}>
      {children}
    </div>
  );
};

InfoList.ItemValue = InfoListItemValue;

const InfoListItemTag = ({ color, children, ...rest }: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      className="inline-block px-2 py-1 font-semibold text-white rounded-sm text-3xs"
      style={{ backgroundColor: color }}
      {...rest}
    >
      {children}
    </div>
  );
};

InfoList.ItemTag = InfoListItemTag;

const InfoListLink = ({ action, title, children }: InfoListLinkProps) => {
  if (typeof action === "function") {
    return (
      <div
        onClick={action}
        title={title}
        className="flex items-center justify-between px-3 py-3 text-sm font-semibold cursor-pointer select-none text-text-base-active hover:text-text-base-active-hover"
      >
        {children}
      </div>
    );
  }

  return (
    <a
      href={action}
      title={title}
      className="flex items-center justify-between px-3 py-2 text-sm font-semibold border-0 border-b border-transparent border-solid cursor-pointer select-none text-platform-600"
    >
      {children}
    </a>
  );
};

InfoList.Link = InfoListLink;
